module.exports = __webpack_public_path__ + "img/nevsCardTitGreen.8cba41e7.png";